jQuery(document).ready(function() {
    wowo(jQuery);
    slider();
    headerMenu();
    changeLiHeight();
    page_scroll();
    faqToggle();
    videoControl();
    pdp();
    cartCount();
    parallax();

    if(jQuery('.template-index .products_slider').length > 0){
        jQuery('.template-index .products_slider li').eq(0).addClass('wowo fadeInRight delay-in-1');
        jQuery('.template-index .products_slider li').eq(1).addClass('wowo fadeInRight delay-in-3');
        jQuery('.template-index .products_slider li').eq(2).addClass('wowo fadeInRight delay-in-5');
    }
  
  jQuery('.search_item input').bind('input propertychange', function() {
    var val = jQuery(this).val();
    if(val!=''){
    }else{
      jQuery('.snize-ac-results').addClass('hideresults');
      setTimeout(function () {
        jQuery('.snize-ac-results').removeClass('hideresults');
      }, 500);
    }
  });
  
  jQuery('.search_item input').blur(function(){
    if(!jQuery('body').hasClass('snize-instant-widget-is-open')){
      var val = jQuery(this).val();
      if(val==''){
      }else{
        jQuery('.snize-ac-results').addClass('hideresults');
        setTimeout(function () {
          jQuery('.snize-ac-results').removeClass('hideresults');
        }, 500);
      }
    }
  });
  jQuery('.search_item input').focus(function(){
    if(jQuery('body').hasClass('snize-instant-widget-is-open')){
      var val = jQuery(this).val();
      if(val!=''){
      }else{
        jQuery('.snize-ac-results').addClass('hideresults');
        setTimeout(function () {
          jQuery('.snize-ac-results').removeClass('hideresults');
        }, 500);
      }
    }
  });

    if(jQuery("#instafeed").length>0){
        var InstagramToken = $("#instafeed").attr('data-key');
        var link = $("#instafeed").attr('data-link');
        var feed = new Instafeed({
            accessToken: InstagramToken,
            limit: 6,
            template: '<li><a href=' + link + ' target="_blank"><div style="background-image: url({{image}})"></div></a></li>',
            after: function () {},
        });
        feed.run();
    }

    jQuery('.site-nav__dropdown ul').prepend('<li class="btn_hide"><span class="menu_close"></span></li>');
    jQuery('header .site-nav').append('<li><a class="site-nav__link site-nav__link--main search_toggle"><span>Search</span></a></li>');
    jQuery('.aside_menu .mobile_menu .site-nav').append('<li><a class="site-nav__link site-nav__link--main search_toggle"><span>Search</span></a></li>');
    
});


jQuery(window).scroll(function() {
    wowo(jQuery);
    parallax();

    if(jQuery('header').hasClass('has_banner')){
        if (jQuery(document).scrollTop() <= 60){
            jQuery('header').removeClass('sticky');
        }else{
            jQuery('header').addClass('sticky');
        }
    }

    if(jQuery('.text_img .circle_group').length > 0){
        jQuery('.circle_group').each(function(){
            var c = jQuery(this),
                circleTop = c.offset().top;
            if (jQuery(document).scrollTop() > circleTop - jQuery('header').height() - 60){
                c.children('.circle_item').addClass('to_center');
            }else{
                c.children('.circle_item').removeClass('to_center');
            }
        })
        
    }

});

jQuery(window).resize(function () {
    changeLiHeight();
    if(jQuery(window).outerWidth() < 768){
        jQuery('.aside_menu').css('z-index','10000');
    }else if(jQuery(window).outerWidth() >= 768 && jQuery('.site-nav__dropdown').children('ul').hasClass('show_left')){
        jQuery('.aside_menu').css('z-index','9998');
    }
});

function wowo($) {
    setTimeout(function () {
        jQuery('html').addClass("show-c");
        
        var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
        jQuery(".wowo:not(.animated)").each(function () {
            var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
                    limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass("animated");
            }
        })
    }, 100);
}

function headerMenu(){

    jQuery('body').on('click','.site-nav--has-dropdown button',function(){
        jQuery('.mobile_menu .site-nav').children('li').removeClass('wowo fadeInLeft animated');
        jQuery('.mobile_menu .account_list').children('li').removeClass('wowo fadeInLeft delay-in-5 animated');
        
        jQuery('body').addClass('body-hidden');
        // jQuery('header .site-nav__dropdown').fadeIn(400);
        jQuery('.site-nav__dropdown').fadeIn(500);
        jQuery('.aside_menu').fadeIn(500);
        if(jQuery(window).outerWidth() >= 768){
            jQuery('.aside_menu').css('z-index','9998');
        }
        jQuery('.mobile_menu').addClass('show_left');

        jQuery('.site-nav__dropdown').children('ul').addClass('show_left');
        // jQuery(this).siblings('.site-nav__dropdown').fadeIn(400);
        // jQuery(this).siblings('.site-nav__dropdown').children('ul').addClass('show_left');
        setTimeout(function(){
            jQuery('.site-nav__dropdown').find('li:not(.btn_hide)').addClass('wowo fadeInLeft animated');
        }, 300);
    })

    jQuery('body').on('click','.btn_hide span',function(){
        jQuery('body').removeClass('body-hidden');
    })

    jQuery('body').on('click','.hamburger',function(){
        jQuery('body').addClass('body-hidden');
        jQuery('.aside_menu').fadeIn(500);
        jQuery('.mobile_menu').addClass('show_left');
        jQuery('.mobile_menu .site-nav').children('li').eq(0).addClass('wowo fadeInLeft animated');
        jQuery('.mobile_menu .site-nav').children('li').eq(1).addClass('wowo fadeInLeft delay-in-1 animated');
        jQuery('.mobile_menu .site-nav').children('li').eq(2).addClass('wowo fadeInLeft delay-in-3 animated');
        jQuery('.mobile_menu .account_list').children('li').eq(0).addClass('wowo fadeInLeft delay-in-5 animated');
        jQuery('.mobile_menu .account_list').children('li').eq(1).addClass('wowo fadeInLeft delay-in-7 animated');
    })

    jQuery('body').on('click','.search_toggle',function(){
        jQuery('body').addClass('body-hidden');
        jQuery('.aside_menu').fadeIn(500);
        jQuery('.mobile_menu').addClass('show_left');
        jQuery('.search_menu').addClass('show_left');
        jQuery('.search_menu .menu_item').addClass('wowo animated');
    })

    jQuery('body').on('click','.mobile_menu .mobile_menu_close',function(){
        jQuery('body').removeClass('body-hidden');
        jQuery('.aside_menu').fadeOut(500);
        jQuery('.mobile_menu').removeClass('show_left');
        jQuery('.site-nav__dropdown').fadeOut(500);
        jQuery('.site-nav__dropdown ul').removeClass('show_left');
    })

    jQuery('body').on('click','.menu_close',function(){
        jQuery('.aside_menu').css('z-index','10000');
        if(jQuery('.mobile_menu').hasClass('show_left')){
            if(jQuery(window).width() >= 768){
                jQuery('.aside_menu').fadeOut(500);
                jQuery('body').removeClass('body-hidden');
            }
        }else{
            jQuery('.aside_menu').fadeOut(500);
            jQuery('body').removeClass('body-hidden');
        }
        jQuery('.site-nav__dropdown').children('ul').removeClass('show_left');
        jQuery('.search_menu').removeClass('show_left');
        jQuery('.account_menu').removeClass('show_right');
        jQuery('.cart_menu').removeClass('show_right');
        jQuery('.site-nav__dropdown').fadeOut(500);
        jQuery('.form_reset').fadeOut(500);
        setTimeout(function(){
            jQuery('.form_login').fadeIn(500).css('display','flex');
        }, 500);
        jQuery('.menu_item').removeClass('wowo animated');
        jQuery('.site-nav__dropdown').find('li').removeClass('wowo animated');
    })

    jQuery('body').on('click','.aside_menu',function(){
        jQuery('.aside_menu').css('z-index','10000');
        if(jQuery('.mobile_menu').hasClass('show_left')){
            if(jQuery(window).width() >= 768){
                jQuery('.aside_menu').fadeOut(500);
                jQuery('body').removeClass('body-hidden');
            }
        }else{
            jQuery('.aside_menu').fadeOut(500);
            jQuery('body').removeClass('body-hidden');
        }
        jQuery('.site-nav__dropdown').children('ul').removeClass('show_left');
        jQuery('.search_menu').removeClass('show_left');
        jQuery('.account_menu').removeClass('show_right');
        jQuery('.cart_menu').removeClass('show_right');
        jQuery('.site-nav__dropdown').fadeOut(500);
        jQuery('.form_reset').fadeOut(500);
        setTimeout(function(){
            jQuery('.form_login').fadeIn(500).css('display','flex');
        }, 500);
        jQuery('.menu_item').removeClass('wowo animated');
        jQuery('.site-nav__dropdown').find('li').removeClass('wowo animated');
    })

    jQuery('body').on('click','.site-nav__dropdown',function(){


        jQuery('.aside_menu').css('z-index','10000');
        if(jQuery('.mobile_menu').hasClass('show_left')){
            if(jQuery(window).width() >= 768){
                jQuery('.aside_menu').fadeOut(500);
                jQuery('body').removeClass('body-hidden');
            }
        }else{
            jQuery('.aside_menu').fadeOut(500);
            jQuery('body').removeClass('body-hidden');
        }
        jQuery('.site-nav__dropdown').children('ul').removeClass('show_left');
        jQuery('.search_menu').removeClass('show_left');
        jQuery('.account_menu').removeClass('show_right');
        jQuery('.cart_menu').removeClass('show_right');
        jQuery('.site-nav__dropdown').fadeOut(500);
        jQuery('.form_reset').fadeOut(500);
        setTimeout(function(){
            jQuery('.form_login').fadeIn(500).css('display','flex');
        }, 500);
        jQuery('.menu_item').removeClass('wowo animated');
        jQuery('.site-nav__dropdown').find('li').removeClass('wowo animated');
    })

    jQuery('body').on('click','.mobile_menu',function(event){
        event.stopPropagation();
    })

    jQuery('body').on('click','.account_menu',function(event){
        event.stopPropagation();
    })

    jQuery('body').on('click','.cart_menu',function(event){
        event.stopPropagation();
    })

    jQuery('body').on('click','.search_menu',function(event){
        event.stopPropagation();
    })

    jQuery('body').on('click','.site-nav__dropdown ul',function(event){
        event.stopPropagation();
    })

    jQuery('body').on('click','.login_open',function(){
        jQuery('body').addClass('body-hidden');
        jQuery('.aside_menu').fadeIn(500);
        if(jQuery(window).outerWidth() >= 768){
            jQuery('.mobile_menu').addClass('show_left');
        }
        jQuery('.account_menu').addClass('show_right');
    })

    jQuery('body').on('click','.cart_open',function(){
        jQuery('body').addClass('body-hidden');
        jQuery('.aside_menu').fadeIn(500);
        if(jQuery(window).outerWidth() >= 768){
            jQuery('.mobile_menu').addClass('show_left');
        }
        jQuery('.cart_menu').addClass('show_right');
    })

    jQuery('body').on('click','.forget',function(){
        jQuery('.form_login').fadeOut(500);
        setTimeout(function(){
            jQuery('.form_reset').fadeIn(500).css('display','flex');
        }, 500);
    })

    jQuery('body').on('click','.cancel',function(){
        jQuery('.form_reset').fadeOut(500);
        setTimeout(function(){
            jQuery('.form_login').fadeIn(500).css('display','flex');
        }, 500);
    })
}

function page_scroll(){
    jQuery(".scroll").click(function(event){
        var sTop = jQuery('header').height();
        event.preventDefault();
        jQuery('html,body').animate({scrollTop:jQuery(this).parents('.shopify-section').next().offset().top - sTop},800);
    });
}

function changeLiHeight(){
    if(jQuery(window).outerWidth() < 768){
        var first_li_width = jQuery('#instafeed li').eq(0).css('width');
        var other_li_width = jQuery('#instafeed li').eq(1).css('width');
        jQuery('#instafeed li').css('height',other_li_width);
        jQuery('#instafeed li').eq(0).css('height',first_li_width);
    }else{
        var li_width = jQuery('#instafeed li').css('width');
        jQuery('#instafeed li').css('height',li_width);
    }
}

function videoControl(){
    jQuery('body').on('click','.btn_control',function(event){
        jQuery(this).fadeOut().siblings('video')[0].play();
        event.stopPropagation();
    })

    // jQuery('body').on('click','.video_box .video_item',function(){
    //     // jQuery(this).children('video')[0].pause();
    //     showBtn();
    // })
}

function pdp(){
    jQuery('body').on('click','.btn_reduce',function(){
        var counter = jQuery('#Quantity-product-template').val();
        if(counter > 1){
            counter -= 1;
        }
        jQuery('#Quantity-product-template').val(counter);
    })

    jQuery('body').on('click','.btn_add',function(){
        var counter = jQuery('#Quantity-product-template').val();
        counter -= -1;
        jQuery('#Quantity-product-template').val(counter);
    })

    jQuery('body').on('click','.pop_control .item',function(){
        var popTitle = jQuery(this).children('span').text();
        // jQuery('.pop .text').append('<h3>' + popTitle + '</h3>');

        // for (var i = 0; i < jQuery(this).children('.pop_text').children().length; i++) {
        //     var popTag = jQuery(this).children('.pop_text').children().eq(i)[0].tagName.toLowerCase();
        //     var popText = jQuery(this).children('.pop_text').children().eq(i).html();
        //     jQuery('.pop .text').append('<' + popTag + '>' + popText + '</' + popTag + '>');
        // }

        var popHtml = jQuery(this).children('.pop_text').html();
        jQuery('.pop .text').html('<h3>' + popTitle + '</h3>' + popHtml);

        jQuery('.pop').fadeIn(500);
        jQuery('.pop').addClass('is_open');
        jQuery('html').addClass('body-hidden');
    })

    jQuery('body').on('click','.swatch-anchor',function(){
        jQuery(this).addClass('label_checked').parent().siblings().find('.swatch-anchor').removeClass('label_checked');
    })

    jQuery('body').on('click','.pop .btn_pop_close',function(){
        jQuery('.pop').removeClass('is_open');
        jQuery('.pop').fadeOut(500);
        jQuery('html').removeClass('body-hidden');
        setTimeout(function(){
            jQuery('.pop .text').children().remove();
        }, 300);
    })

    jQuery('body').on('click','.pop',function(){
        jQuery('.pop').removeClass('is_open');
        jQuery('.pop').fadeOut(500);
        jQuery('html').removeClass('body-hidden');
        setTimeout(function(){
            jQuery('.pop .text').children().remove();
        }, 300);
    })

    jQuery('body').on('click','.pop_content',function(event){
        event.stopPropagation();
    })
}

function cartCount(){
    jQuery('body').on('click','.cart_btn_reduce',function(){
        var item_counter = jQuery(this).siblings('.cart__qty-input').val();
        if(item_counter > 1){
            item_counter -= 1;
        }
        jQuery(this).siblings('.cart__qty-input').val(item_counter);
      
      	var item_id = jQuery(this).parents('.cart__row').attr('data-item-id');
      	jQuery.ajax({
            url:'/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: { quantity:item_counter, id:item_id },
            success: function(msg) {
                var total = 0;
                for(var i in msg.items){
                    var row_price = (msg.items[i].line_price / 100);
					total = total + row_price;
                }
              var sub_total = total.toFixed(2);
              var a = parseInt(sub_total.slice(0,sub_total.length - 3)).toLocaleString();
              var b = sub_total.slice(sub_total.length - 3,sub_total.length);
              var c = a + b;
              
              jQuery('.cart-subtotal__price').text('$' + c + ' AUD');
            }
        });
    })

    jQuery('body').on('click','.cart_btn_add',function(){
        var item_counter = jQuery(this).siblings('.cart__qty-input').val();
        item_counter -= -1;
        jQuery(this).siblings('.cart__qty-input').val(item_counter);
      
      	var item_id = jQuery(this).parents('.cart__row').attr('data-item-id');
        jQuery.ajax({
            url:'/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: { quantity:item_counter, id:item_id },
            success: function(msg) {
                var total = 0;
                for(var i in msg.items){
                    var row_price = (msg.items[i].line_price / 100);
					total = total + row_price;
                }
              var sub_total = total.toFixed(2);
              var a = parseInt(sub_total.slice(0,sub_total.length - 3)).toLocaleString();
              var b = sub_total.slice(sub_total.length - 3,sub_total.length);
              var c = a + b;
              
              jQuery('.cart_menu .cart-subtotal__price').text('$' + c + ' AUD');
            }
        });
    })
}

function showBtn(){
    jQuery('.btn_control').fadeIn();
}

function hideBtn(){
    jQuery('.btn_control').fadeOut();
}

function faqToggle(){
    jQuery('body').on('click','.FAQ_list li .question',function(){
        jQuery(this).parent().toggleClass('is_open').siblings().removeClass('is_open');
        jQuery(this).siblings('.answer').slideToggle(400);
        jQuery(this).parent().siblings().find('.answer').slideUp(400);
    })
}

function parallax() {
    if(jQuery(window).width() >= 768){
        var wh = jQuery(window).height();
        var sh = jQuery(window).scrollTop();
        jQuery(".parallax-s").each(function(){
            var parallax_h = jQuery(this).offset().top;
            if(sh>(parallax_h-wh)){
                var parallax_y = -(sh-(parallax_h-wh))/12;
                // var attgroup = 'center ' + parallax_y;
                // jQuery(this).css('background-position','center ' + parallax_y + 'px');
                jQuery(this).css('top',parallax_y);
            }
        });
    }else{
        // jQuery('.parallax-s').css('background-position','center');
        jQuery(this).css('top',0);
    }
}

function slider(){
    if(jQuery('.vitamins_on_a_mission:not(.our_products) .products_slider').length>0){  
        jQuery('.vitamins_on_a_mission:not(.our_products) .products_slider').slick({
            slidesToShow:3,
            slidesToScroll: 1,
            fade: false,
            arrows: true,
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: false,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    }

    if(jQuery('.image_text .item').length>0){  
        jQuery('.image_text .item .img').slick({
            slidesToShow:1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            draggable: false,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 5000,
        });
    }
  
    jQuery('.products_slider').on('beforeChange', function(event, slick, direction){
          jQuery('.products_slider img').addClass('img_opacity');    
    });

    jQuery('.products_slider').on('afterChange', function(event, slick, direction){
      jQuery('.products_slider img').removeClass('img_opacity');    
    });

    if(jQuery('.is_show').length>0 && jQuery('.product_img_slider').length>0){
        jQuery('.is_show').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            draggable: false,
            asNavFor: '.product_img_slider',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: true,
                        draggable: true
                    }
                }
            ]
        });

        jQuery('.product_img_slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.is_show',
            dots: false,
            arrows: false,
            centerMode: true,
            centerPadding: "0",
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    }
}

window.onload=function(){
    if(jQuery('.pdp_product .products_slider').length>0){  
        jQuery('.pdp_product .products_slider').slick({
            slidesToShow:3,
            slidesToScroll: 1,
            fade: false,
            arrows: true,
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: false,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
    }
  
    jQuery('.pdp_product .products_slider').on('beforeChange', function(event, slick, direction){
        jQuery('.products_slider img').addClass('img_opacity');    
    });

    jQuery('.pdp_product .products_slider').on('afterChange', function(event, slick, direction){
      jQuery('.products_slider img').removeClass('img_opacity');    
    });
}

jQuery('.client_logos').slick({
   slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
    arrows: true,
   infinite: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

});